import React from 'react'

import classes from './layout.css'
import Checkbox from '../Fields/Checkbox'

const ModuleTwentyNine = (props) => {
	return (
		<div className={classes.Section}>
			<h3><u>YOUR OBLIGATIONS IF CONSCIOUS SEDATION OR GENERAL ANESTHESIA IS USED:</u></h3>
			<div className={classes.ListItem}>
				<Checkbox
					controlFunc={props.addToForm}
					name={"anesthesiaConsent1"}
					value={props.consentForm.anesthesiaConsent1}
				/>
				Because anesthetic medications cause prolonged dowsiness, you MUST be accompanied by a responsible adult to drive you home and stay with you until you are sufficiently recovered to care for yourself. This may be up to 24 hours.
			</div>

			<div className={classes.ListItem}>
				<Checkbox
					controlFunc={props.addToForm}
					name={"anesthesiaConsent2"}
					value={props.consentForm.anesthesiaConsent2}
				/>
				During recovery time (typically 24 hours) and during the time you are taking any medications which can alter your judgment or physical abilities, you should not drive, operate complicated machinery or devices, or make important decisions such as signing documents, etc.
			</div>

			<div className={classes.ListItem}>
				<Checkbox
					controlFunc={props.addToForm}
					name={"anesthesiaConsent3"}
					value={props.consentForm.anesthesiaConsent3}
				/>
				<u>
					You must have a completely empty stomach. IT IS VITAL THAT YOU HAVING NOTHING TO EAT OR DRINK FOR <strong>EIGHT (8) HOURS</strong> PRIOR TO YOUR ANESTHETIC. <strong>TO DO OTHERWISE MAY BE LIFE-THREATENING!</strong>
				</u>
			</div>

			<div className={classes.ListItem}>
				<Checkbox
					controlFunc={props.addToForm}
					name={"anesthesiaConsent4"}
					value={props.consentForm.anesthesiaConsent4}
				/>
				<strong>Unless instructed otherwise, </strong> it is important that you take any regular medications (high blood pressure, antibiotics, etc.) or any medications provided by your surgeon, <strong>using only a small sip of water.</strong>
			</div>
		</div>
	)
}

export default ModuleTwentyNine


// WEBPACK FOOTER //
// ./src/components/Modules/29.js